import {createReducer} from '../utils/createReducer'
import { NewsCriteria } from 'src/type/criteria/newsCriteria'
import { _ECOWATCH } from '../../action/ecoWatchAction'

export interface IEcoWatchState<T> {
  route?: Promise<IEcoWatchState<T>>;
  isFetching: boolean;
  entities?: T[];
  criteria: NewsCriteria;
  total_size?: number;
  error?: string
}

const defaultState: IEcoWatchState<any> = {
  route: undefined,
  isFetching: false,
  entities: undefined,
  total_size: undefined,
  criteria: {
      limit: 2, 
      offset: 0, 
      order_by: 'asc',
      target_id: null
  },
  error: undefined,
}

const request = <T>(state: IEcoWatchState<T>, action) => ({
  ...state,
  isFetching: true,
})

const success = <T>(state: IEcoWatchState<T>, action) => ({
  ...state,
  isFetching: false,
  entities: action.data.data,
  total_size: action.data.total_size,
})

const failure = <T>(state: IEcoWatchState<T>, action) => ({
  ...state,
  isFetching: false,
  error: action.error,
})


const updateCriteria = <T>(state: IEcoWatchState<T>, action) => ({
  ...state,
  criteria: {
    ...state.criteria,
    order_by: 'desc',
    sort_by: 'publish_at',
    [action.name]: action.value
  },
})

const updateCriteriaByFilter = <T>(state: IEcoWatchState<T>, action) => ({...state,
  criteria: {
    ...state.criteria,
    category_actu: action.obj.get('actu').join(),
    category_actu_nuage: action.obj.get('actu-nuage').join(),
    category_produit: action.obj.get('produit').join(),
    category_principale: action.obj.get('principale').join(),
  },
})

const updateObjectCriteria = <T>(state: IEcoWatchState<T>, action) => ({
    ...state,
    criteria: {
      ...state.criteria,
      ...action.object
    },
})

export default <T>(name: string) => createReducer<IEcoWatchState<T>>(defaultState, {
  [_ECOWATCH(name).REQUEST]: request,
  [_ECOWATCH(name).SUCCESS]: success,
  [_ECOWATCH(name).FAILURE]: failure,
  [_ECOWATCH(name).UPDATE_CRITERIA]: updateCriteria,
  [_ECOWATCH(name).UPDATE_OBJECT_CRITERIA]: updateObjectCriteria,
  [_ECOWATCH(name).UPDATE_CRITERIA_BY_FILTER]: updateCriteriaByFilter
})



// WEBPACK FOOTER //
// ./src/core/redux/reducer/generic/ecoWatchReducer.ts